export async function sendRequest(obj) {
  let { endpointUrl: url } = obj || this.state
  const {
    method,
    paramsArr = [],
    headersArr = [],
    body = null,
    authArr = []
  } = obj || this.state
  return new Promise(async (resolve, reject) => {
    // Construct query string from params array
    if (paramsArr.length > 0) {
      const queryString = paramsArr
        .map(
          (param) =>
            `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`
        )
        .join('&')
      url += `?${queryString}`
    }

    // Construct headers object from headers array
    const headersObject = {}
    headersArr.forEach((header) => {
      headersObject[header.key] = header.value
    })

    // Construct auth string if provided
    let authString = null
    if (authArr.length > 0) {
      const authPair = authArr.find((a) => a.key && a.value)
      if (authPair) {
        authString = `${authPair.key}:${authPair.value}`
      }
    }

    // Set up fetch options
    const options = {
      method,
      headers: headersObject
    }

    if (authString) {
      options.headers.Authorization = `Basic ${btoa(authString)}`
    }

    if (body && method !== 'GET') {
      options.body = typeof body === 'string' ? body : JSON.stringify(body)
    }

    // Prevent body from being added for GET requests
    if (method === 'GET') {
      options.body = null
    }

    // Send the request
    return await fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          return reject(
            new Error(
              `Request failed with status ${response.status}: ${response.statusText}`
            )
          )
        }
        return response.json()
      })
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(`Network error occurred: ${error.message}`)) // eslint-disable-line
  })
}
